function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.333 4L5.667 6H4a1.994 1.994 0 00-1.995 1.85L2 8v6c0 1.113.895 2 2 2h6c1.113 0 2-.895 2-2V9.714l2-2.571v7.854A3.002 3.002 0 0110.997 18H3.003A3.002 3.002 0 010 14.997V7.003A3.002 3.002 0 013.003 4h4.33zm-2.72 6.256l3.277 2.295L4 14.71l.614-4.454zm5.163-7.372l3.277 2.294-4.589 6.553-3.277-2.294 4.59-6.553zM12.897.186l1.623 1.137c.457.32.573.941.254 1.397l-1.148 1.64-3.276-2.295 1.147-1.64a.999.999 0 011.4-.239z",
  fill: "#4092D7",
  fillRule: "evenodd"
});

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.ddc959f4.svg";
export { ForwardRef as ReactComponent };